import React from 'react';
import {
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { dataAttrs } from 'Helpers/Testing';
import { OverviewSectionInfos } from './OverviewSectionInfos';


const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['info'], {
    _component: () => OverviewSectionInfos,
  }, overrideReadOnly);


export const OverviewSectionLayout = ({
  resource,
}) => {
  return (
    <FDStack direction={'column'} spacing={2} {...dataAttrs('goal-strategy-detail-overview-section')}>
      <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'info'} />
    </FDStack>
  );
};

OverviewSectionLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
